import React from 'react';

interface FallbackWidgetProps {
  type?: string;
  variant?: string;
  error?: string;
}

const FallbackWidget: React.FC<FallbackWidgetProps> = ({ 
  type = 'Unknown', 
  variant = 'default',
  error 
}) => {
  return (
    <div className="flex items-center justify-center p-8 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg">
      <div className="text-center">
        <div className="text-gray-500 mb-2">
          <svg 
            className="w-12 h-12 mx-auto mb-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" 
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Widget Not Found
        </h3>
        <p className="text-sm text-gray-600 mb-1">
          <span className="font-medium">Type:</span> {type}
        </p>
        <p className="text-sm text-gray-600 mb-3">
          <span className="font-medium">Variant:</span> {variant}
        </p>
        {error && (
          <p className="text-xs text-red-600 bg-red-50 p-2 rounded">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default FallbackWidget;
